var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopic2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_611",
    "data-name": "Group 611",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 79.013,
    height: 79,
    viewBox: "0 0 79.013 79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140",
    "data-name": "Rectangle 140",
    width: 79.013,
    height: 79,
    fill: "#2e90d8",
    stroke: "#2e90d8",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_610",
    "data-name": "Group 610",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43611",
    "data-name": "Path 43611",
    d: "M0,5.558c.089-.261.189-.519.267-.783A6.589,6.589,0,0,1,6.494.009C7.445-.009,8.4,0,9.348,0q31.36,0,62.72,0a6.585,6.585,0,0,1,6.871,5.684A8.138,8.138,0,0,1,79.01,7q0,25.916,0,51.831a6.632,6.632,0,0,1-7.007,7.019c-.921,0-1.842,0-2.816,0V62.529c.613,0,1.242,0,1.872,0,.591,0,1.184.013,1.773-.027a2.925,2.925,0,0,0,2.8-2.519,8.328,8.328,0,0,0,.1-1.381q.007-25.684,0-51.369a8.512,8.512,0,0,0-.084-1.3,2.9,2.9,0,0,0-2.584-2.565,7.985,7.985,0,0,0-1.228-.078q-32.324-.005-64.649,0a8.132,8.132,0,0,0-1.3.09,2.885,2.885,0,0,0-2.5,2.468,7.307,7.307,0,0,0-.1,1.226q-.007,25.839,0,51.677a7.3,7.3,0,0,0,.1,1.3,2.931,2.931,0,0,0,2.7,2.447c.383.034.771.031,1.156.031q10.685,0,21.37,0h.962v3.317H28.7q-10.8,0-21.6,0a6.62,6.62,0,0,1-7-5.466.971.971,0,0,0-.107-.2V5.558",
    transform: "translate(0 0)",
    fill: "#2e90d8",
    stroke: "#2e90d8",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43612",
    "data-name": "Path 43612",
    d: "M150.43,142.351c-.013-.359-.037-.718-.037-1.078q0-13.031.01-26.063a1.787,1.787,0,0,0-.6-1.4A19.756,19.756,0,1,1,183,96.27a19.592,19.592,0,0,1-5.714,17.535,1.839,1.839,0,0,0-.6,1.405q.027,13.031.011,26.063c0,.359-.024.718-.037,1.077h-.154a2.037,2.037,0,0,0-.342-.275c-4.039-2.024-8.076-4.052-12.131-6.042a1.361,1.361,0,0,0-1.051.035c-3.982,1.963-7.948,3.958-11.915,5.95a4.318,4.318,0,0,0-.486.332ZM163.518,116a16.45,16.45,0,1,0-16.441-16.454A16.3,16.3,0,0,0,163.518,116m9.857,21.051v-20.33a19.954,19.954,0,0,1-19.653,0v20.308c.3-.14.529-.242.754-.354,2.824-1.408,5.652-2.808,8.466-4.236a1.133,1.133,0,0,1,1.2-.016c1.126.613,2.289,1.159,3.437,1.732l5.795,2.892",
    transform: "translate(-114.164 -63.351)",
    fill: "#2e90d8",
    stroke: "#2e90d8",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_136",
    "data-name": "Rectangle 136",
    width: 16.372,
    height: 3.239,
    transform: "translate(9.93 23.078)",
    fill: "#d2e7f7",
    stroke: "#d2e7f7",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_137",
    "data-name": "Rectangle 137",
    width: 13.058,
    height: 3.216,
    transform: "translate(9.914 32.94)",
    fill: "#2e90d8",
    stroke: "#2e90d8",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138",
    "data-name": "Rectangle 138",
    width: 9.791,
    height: 3.194,
    transform: "translate(23.07 13.227)",
    fill: "#2e90d8",
    stroke: "#2e90d8",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_139",
    "data-name": "Rectangle 139",
    width: 6.507,
    height: 3.21,
    transform: "translate(9.921 13.215)",
    fill: "#d2e7f7",
    stroke: "#d2e7f7",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43613",
    "data-name": "Path 43613",
    d: "M176.119,128.736a16.45,16.45,0,1,1,16.5-16.4,16.3,16.3,0,0,1-16.5,16.4m.041-26.3a9.873,9.873,0,1,0,9.865,9.852,9.68,9.68,0,0,0-9.865-9.852",
    transform: "translate(-126.766 -76.083)",
    fill: "#2e90d8",
    stroke: "#2e90d8",
    strokeWidth: 1,
    opacity: 0.307
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43614",
    "data-name": "Path 43614",
    d: "M211.573,279.28l-5.795-2.892c-1.148-.573-2.311-1.119-3.437-1.732a1.133,1.133,0,0,0-1.2.016c-2.814,1.428-5.642,2.828-8.466,4.236-.225.112-.455.214-.754.354V258.954a19.954,19.954,0,0,0,19.653,0Z",
    transform: "translate(-152.362 -205.576)",
    fill: "#2e90d8",
    stroke: "#2e90d8",
    strokeWidth: 1,
    opacity: 0.216
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43615",
    "data-name": "Path 43615",
    d: "M201.559,127.843a9.873,9.873,0,1,1-9.887,9.829,9.676,9.676,0,0,1,9.887-9.829m.019,16.424a6.572,6.572,0,1,0-6.621-6.536,6.6,6.6,0,0,0,6.621,6.536",
    transform: "translate(-152.165 -101.492)",
    fill: "#2e90d8",
    stroke: "#2e90d8",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43616",
    "data-name": "Path 43616",
    d: "M214.231,156.9a6.572,6.572,0,1,1,6.561-6.6,6.6,6.6,0,0,1-6.561,6.6",
    transform: "translate(-164.818 -114.123)",
    fill: "#2e90d8",
    stroke: "#2e90d8",
    strokeWidth: 1,
    opacity: 0.356
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopic2);
export default __webpack_public_path__ + "static/media/topic2.c4cd9934c729417ee72829c8f348559e.svg";
export { ForwardRef as ReactComponent };